module.exports = __webpack_public_path__ + "img/icon-image-add.324db823.svg";